import React from 'react';
import IntroSection from '../components/IntroSection';
import LegalSolutions from '../components/LegalSolutions';
import BlueSectionDivider from '../components/BlueSectionDivider';
import LegalBenefits from '../components/LegalBenefits';
import CountriesSection from '../components/CountriesSection';
import TechStackSection from '../components/TechStackSection';
import LegalFaq from '../components/LegalFaq';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';


const Legaltech = () => {
    return (
        <div>
            <IntroSection title="Legaltech Solutions" paragraph="Transforming legal processes and empowering legal professionals with digital innovation" backgroundImage="/images/legal-bg.webp"/>
            
            <LegalSolutions/>
            <BlueSectionDivider/>
            <LegalBenefits imageSrc="https://cdn.prod.website-files.com/63d3b504212f2224c6e39423/65830ca3bdbcd77576dee450_Technical%20consultancy%20fintech.png"/>
            <BlueSectionDivider/>
            <CountriesSection/>
            <BlueSectionDivider/>
            <TechStackSection/>
            <BlueSectionDivider/>
            <LegalFaq/>
            <ContactSection backgroundColor="#057af0ff"/>
            <Footer/>

        </div>
    )
}
export default Legaltech;
